// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202511131534/js/" + chunkId + "." + {"44":"9eeb53d6","225":"91281519","481":"821dad84","486":"d0449d83","770":"f89884e1"}[chunkId] + ".0.28711568391486275.chunk.js";
};